import * as React from "react";
import { SVGProps } from "react";

const Nucypher = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 579 374" {...props}>
    <path
      fill="#1e65f3"
      d="m442.8.2-48.3 22.9c-.2.1-.5.3-.6.5-.2.2-.3.4-.4.7-.1.3-.1.5-.1.8 0 .3.1.5.2.8L467 180.6c27.3 57.6 20 101.2-21.5 121-33.6 15.9-62.5 4.8-85.1-34l-87-183.3c-35.2-74.3-83.2-94-140.2-66.9-37 17.6-58.5 49-58.1 88.9 0 .5-.1.9-.4 1.3-.3.4-.7.6-1.2.7-.5.1-.9.1-1.4-.1-.4-.2-.8-.5-1-1l-19-40c-.1-.2-.3-.5-.5-.6-.2-.2-.4-.3-.7-.4-.2-.2-.4-.2-.7-.2-.3 0-.5.1-.8.2L1.2 89.1c-.5.2-.9.6-1 1.2-.2.5-.2 1.1.1 1.6L133.6 373c.2.5.7.9 1.2 1.1.5.2 1.1.2 1.6-.1l48.3-22.9c.2-.1.5-.3.6-.5.2-.2.3-.4.4-.7.1-.3.1-.5.1-.8 0-.3-.1-.5-.2-.8l-71.4-150.4C85.1 136.5 90.6 92.1 135.1 71c34.2-16.2 60.8-5.3 84.7 36.3 0 0 .1.1.1.2L306 288.9c33.2 70 84.8 94 139.2 68.2 42.1-20 59.6-50 58.5-89.6 0-.5.1-.9.4-1.3.3-.4.7-.6 1.2-.7.5-.1.9-.1 1.4.1.4.2.8.5 1 1l19.2 40.4c.1.2.3.5.5.6.2.2.4.3.7.4.3.1.5.1.8.1.3 0 .5-.1.8-.2L578 285c.2-.1.5-.3.6-.5.2-.2.3-.4.4-.7.1-.3.1-.5.1-.8s-.1-.5-.2-.8L445.5 1.2c-.2-.5-.7-.9-1.2-1.1-.5-.2-1.1-.1-1.5.1z"
    />
  </svg>
);

export default Nucypher;
